import React from 'react';
import PropTypes from 'prop-types';

const STATUS_META = {
  connected: { label: 'Conectado', className: 'ok', icon: 'bi bi-circle-fill' },
  disconnected: { label: 'Desconectado', className: 'off', icon: 'bi bi-circle-fill' },
  reconnecting: { label: 'Reconectando', className: 'warn', icon: 'bi bi-arrow-repeat' },
  connecting: { label: 'Conectando', className: 'warn', icon: 'bi bi-arrow-repeat' }
};

function WhatsAppStatusCard({ status, phone, onOpenQr, onLogout, loadingLogout }) {
  const meta = STATUS_META[status] || STATUS_META.disconnected;
  const isConnected = status === 'connected';

  return (
    <section className="wa-admin-card">
      <header className="wa-admin-card-header">
        <h3 className="wa-admin-card-title">Estado de conexion</h3>
        <span className={`wa-status-badge ${meta.className}`}>
          <i className={meta.icon} aria-hidden="true" />
          {meta.label}
        </span>
      </header>

      <div className="wa-admin-card-body">
        <div className="wa-status-grid">
          <div>
            <p className="wa-admin-label">Numero actual</p>
            <p className="wa-admin-value">{phone || 'Sin vincular'}</p>
          </div>
          <div>
            <p className="wa-admin-label">Sesion</p>
            <p className="wa-admin-value">{isConnected ? 'Activa' : 'Inactiva'}</p>
          </div>
        </div>

        <div className="wa-admin-actions">
          {isConnected ? (
            <button
              type="button"
              className="btn btn-danger"
              onClick={onLogout}
              disabled={loadingLogout}
            >
              {loadingLogout ? 'Desconectando...' : 'Desconectar'}
            </button>
          ) : (
            <button type="button" className="btn btn-success" onClick={onOpenQr}>
              Conectar WhatsApp
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

WhatsAppStatusCard.propTypes = {
  status: PropTypes.string,
  phone: PropTypes.string,
  onOpenQr: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  loadingLogout: PropTypes.bool
};

WhatsAppStatusCard.defaultProps = {
  status: 'disconnected',
  phone: '',
  loadingLogout: false
};

export default WhatsAppStatusCard;
